import { Ball, Misc, OvalShading, Player, RectangleShading, TextBox, TrapezoidShading } from "../marker";

export enum HockeyMiscType {
  PUCK_STATIC = "PUCK_STATIC",
  FLAG = "FLAG",
  CONE = "CONE",
  TIRE = "TIRE",
  STICK_RIGHT = "STICK_RIGHT",
  STICK_LEFT = "STICK_LEFT",
  TRIANGLE_STICK = "TRIANGLE_STICK",
  BOARD = "BOARD",
  PILE = "PILE",
  NET = "NET",
}

export type HockeyMiscMarker = Misc<HockeyMiscType>;

export type HockeyMarker =
  | Player
  | Ball
  | TextBox
  | HockeyMiscMarker
  | RectangleShading
  | OvalShading
  | TrapezoidShading;
